export default __webpack_public_path__ + "static/media/formtemplate.af73306c.png";